
//Mui
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { FormContainer, TextFieldElement, SelectElement, MultiSelectElement, AutocompleteElement, DatePickerElement } from 'react-hook-form-mui';
import {
    Button, Box, Avatar, Switch, List, ListItem, ListItemAvatar, ListItemText, Checkbox, DialogTitle, Dialog, Typography, DialogContent,
    TextField, FormControl, Paper, OutlinedInput, FormHelperText, InputLabel, FilledInput, Grid, DialogContentText, DialogActions
} from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { DataGrid, GridToolbar, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarFilterButton, GridToolbarExport, GridToolbarQuickFilterProps, GridToolbarColumnsButton, GridToolbarQuickFilter } from "@mui/x-data-grid";


import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import theme from '../../../theme';
import { Fragment, useState, useEffect } from 'react';
import { getRolesData, addRol, editRol, deleteRol } from "./rolesSlice.js";
import { useSelector, useDispatch } from 'react-redux';

const RolesCat = () => {
    const dispatch = useDispatch();
    const fetching = useSelector(state => state.roles.fetching);
    const { permisos, permisosRolesMap, personas, rolesPersonasMap, roles } = useSelector(state => state.roles.data);
    useEffect(() => { dispatch(getRolesData()) }, []);
    const Header = (props) => {
       
        return (<Fragment>
            <Typography variant="h5" component="div" sx={{ minWidth: 275, margin: '10px' }}>{'Roles'}</Typography>
            {fetching > 0 && <p>Cargando</p>}
        </Fragment>);
    };
    const RolesTable = () => {
        let rows = (roles || [])?.map(r => {
            let personasRol = (rolesPersonasMap || [])?.filter(pr => pr.rolId === r.rolId)
            let permisosRol = permisos?.filter(p => permisosRolesMap?.filter(prm => prm.rolId === r.rolId)?.map(prm => prm.permisoId)?.includes(p.permisoId))
            let permisosDen = permisos?.filter(p => !(permisosRol?.map(prm => prm.permisoId)?.includes(p.permisoId)))?.map(permiso => permiso.descripcion?.replace('Puede ', '')[0].toUpperCase() + permiso.descripcion.replace('Puede ', '').substring(1))
            let permisosDenForm = permisos?.filter(p => !(permisosRol?.map(prm => prm.permisoId)?.includes(p.permisoId)))
            let accesos = []
            let lecturas = []
            let escrituras = []
            let accesosDen = []
            let lecturasDen = []
            let escriturasDen = []
            let permisosDes = permisosRol?.map(permiso => permiso.descripcion.replace('Puede ', '')[0].toUpperCase() + permiso.descripcion.replace('Puede ', '').substring(1))?.forEach(p => {
                p.startsWith('Ver') ? lecturas.push(p) : (p.startsWith('Eliminar') || p.startsWith('Crear')) || (p.startsWith('Editar') || p.startsWith('Generar')) ? escrituras.push(p) : accesos.push(p)
            });
            permisosDen?.forEach(p => {
                p.startsWith('Ver') ? lecturasDen.push(p) : (p.startsWith('Eliminar') || p.startsWith('Crear')) || (p.startsWith('Editar') || p.startsWith('Generar')) ? escriturasDen.push(p) : accesosDen.push(p)
            });
            return ({
                ...r,
                permisosRol: permisosRol,
                permisosDen: permisosDen,
                permisosDes: permisosDes,
                accesos: accesos,
                lecturas: lecturas,
                escrituras: escrituras,
                personasRol: personasRol,
                accesosDen: accesosDen,
                lecturasDen: lecturasDen,
                escriturasDen: escriturasDen,
                permisosDenForm: permisosDenForm
            })
        });
        const [selectedRows, setSelectedRows] = useState(rows.map(r => ({ ...r, selected: false })));
        const [interruptor, setInterruptor] = useState([...rows?.map(r => ({ rolId: r.rolId, switch: false }))])
        const [personasModal, setPersonasModal] = useState(false)
        const PersonasModal = (props) => {
            function getLabel(option) {//U: Used to get the label of the selected option
                if (option.personaFisica) {
                    if (!option.nombre && !option.apellido && !option.numeroDocumento) return option.email;
                    return option.nombre + ' ' + option.apellido + ' - ' + option.numeroDocumento;
                } else {
                    if (!option.denominacionSocial && !option.cuit) return option.email;
                    return option.denominacionSocial + ' - ' + option.cuit;
                }
            }
            let rol = []
            let personasIds = []
            let rowsPersonas = []
            if (personasModal) {
                rol = personasModal[0]?.rolId
                personasIds = personasModal?.map(pm => pm.personaId)
                rowsPersonas = (personas || [])?.filter(p => personasIds?.includes(p.personaId))
            }
            const columns = [
                { field: 'personaId', headerName: 'ID', flex: 7 },
                { field: 'nombre', headerName: 'Persona', flex: 90, valueGetter: (v) => getLabel(v.row) },
                { field: 'email', headerName: 'Email', flex: 80 },
                { field: 'cuit', headerName: 'CUIT/CUIL', flex: 70 },
            ]
            return (
                <Dialog
                    open={personasModal}
                    onClose={() => setPersonasModal(false)}
                    maxWidth='lg'
                >
                    <DialogTitle fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }}>Personas con el rol {rol}:</DialogTitle>
                    <DialogContent dividers>
                        <Box sx={{ height: '450px', width: '900px' }}>
                            <DataGrid
                                getRowId={r => r.personaId}
                                rows={rowsPersonas || []}
                                columns={columns}
                                pageSize={100}
                                rowsPerPageOptions={[5]}
                                experimentalFeatures={{ newEditingApi: true }}
                                //onSelectionModelChange={setSelectedRows}
                                components={{
                                    Toolbar: () => {
                                        return <Fragment>
                                            <GridToolbarContainer>
                                                <Grid conteiner
                                                    rowSpacing={0} sx={{
                                                        display: "inline-flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "strech",
                                                        width: "100%"
                                                    }}>
                                                    <Grid sx={{ width: "100%" }}>
                                                        <GridToolbarColumnsButton /><GridToolbarFilterButton /> <GridToolbarDensitySelector />
                                                        <GridToolbarExport />
                                                    </Grid>
                                                    <GridToolbarQuickFilter />
                                                </Grid>
                                            </GridToolbarContainer>
                                        </Fragment>
                                    }
                                }}
                                componentsProps={{
                                    toolbar: {
                                        showQuickFilter: true,
                                        quickFilterProps: { debounceMs: 500 },
                                    },
                                }}
                            />
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button color='primary' onClick={() => setPersonasModal(false)}>Volver</Button>
                    </DialogActions>
                </Dialog>
            )
        };
        const BtnBar = (props) => {
            const [showNewRolForm, setShowNewRolForm] = useState(false);
            const [showDeleteRolForm, setShowDeleteRolForm] = useState(false);
            const [estamosEditando, setEstamosEditando] = useState(false);

            const NewRolForm = (props) => {
                let accesos = []
                let lecturas = []
                let escrituras = []
                let selected = selectedRows.find(r => r.selected === true)
                let defaultValues = {
                    rolId: estamosEditando ? selected.rolId : '',
                    nombre: estamosEditando ? selected.nombre : '',
                    descripcion: estamosEditando ? selected.nombre : '',
                    permisos: []
                }
                const [name, setName] = useState(defaultValues.nombre)
                let per = permisos?.map(permiso => permiso.permisoId + '. ' + permiso.descripcion.replace('Puede ', '')[0].toUpperCase() + permiso.descripcion.replace('Puede ', '').substring(1))
                per?.forEach(p => {
                    p.startsWith('Ver') ? lecturas.push(p) : (p.startsWith('Eliminar') || p.startsWith('Crear')) || (p.startsWith('Editar') || p.startsWith('Generar')) ? escrituras.push(p) : accesos.push(p)
                })

                const onSubmit = (newRol) => {
                    let aux = { ...defaultValues };
                    let per = right.map(p => parseInt(p.split('.')[0]));
                    aux.nombre = name;
                    aux.descripcion = name;
                    aux.permisos = per;
                    if (estamosEditando) {
                        dispatch(editRol(aux)).unwrap().then(console.log).catch(console.log())
                        setEstamosEditando(false)
                        setShowNewRolForm(false)
                        return
                    } else {
                        delete aux.rolId
                        dispatch(addRol(aux)).unwrap().then(console.log).catch(console.log);
                        setShowNewRolForm(false)
                        return
                    }
                }
                //Componente List Transfer
                function not(a, b) {
                    return a.filter((value) => b.indexOf(value) === -1);
                }

                function intersection(a, b) {
                    return a.filter((value) => b.indexOf(value) !== -1);
                }

                function union(a, b) {
                    return [...a, ...not(b, a)];
                }
                const [checked, setChecked] = useState([]);
                const [left, setLeft] = useState(estamosEditando ? selected?.permisosDenForm?.map(permiso => permiso.permisoId + '. ' + permiso.descripcion) : per);
                const [right, setRight] = useState(estamosEditando ? selected?.permisosRol?.map(permiso => permiso.permisoId + '. ' + permiso.descripcion) : []);

                const leftChecked = intersection(checked, left);
                const rightChecked = intersection(checked, right);

                const handleToggle = (value) => () => {
                    const currentIndex = checked.indexOf(value);
                    const newChecked = [...checked];

                    if (currentIndex === -1) {
                        newChecked.push(value);
                    } else {
                        newChecked.splice(currentIndex, 1);
                    }

                    setChecked(newChecked);
                };

                const numberOfChecked = (items) => intersection(checked, items).length;

                const handleToggleAll = (items) => () => {
                    if (numberOfChecked(items) === items.length) {
                        setChecked(not(checked, items));
                    } else {
                        setChecked(union(checked, items));
                    }
                };

                const handleCheckedRight = () => {
                    setRight(right.concat(leftChecked));
                    setLeft(not(left, leftChecked));
                    setChecked(not(checked, leftChecked));
                };

                const handleCheckedLeft = () => {
                    setLeft(left.concat(rightChecked));
                    setRight(not(right, rightChecked));
                    setChecked(not(checked, rightChecked));
                };

                const CustomList = (title, items) => (
                    <Card key={`card-${title}`}>
                        <CardHeader
                            sx={{ px: 2, py: 1, }}
                            avatar={
                                <Checkbox
                                    onClick={handleToggleAll(items)}
                                    checked={numberOfChecked(items) === items?.length && items?.length !== 0}
                                    indeterminate={
                                        numberOfChecked(items) !== items?.length && numberOfChecked(items) !== 0
                                    }
                                    disabled={items?.length === 0}
                                    inputProps={{
                                        'aria-label': 'all items selected',
                                    }}
                                />
                            }
                            title={<Typography color="text.primary" >{title}</Typography>}
                            subheader={`${numberOfChecked(items)}/${items?.length} selected`}
                        />
                        <Divider />
                        <List
                            sx={{
                                width: 400,
                                height: 350,
                                bgcolor: 'background.paper',
                                overflow: 'auto',
                            }}
                            dense
                            component="div"
                            role="list"
                        >
                            {items?.map((value) => {
                                const labelId = `transfer-list-all-item-${value}-label`;

                                return (
                                    <ListItem
                                        key={`list-item${value.permisoId}`}
                                        role="listitem"
                                        button
                                        onClick={handleToggle(value)}
                                    >
                                        <ListItemIcon>
                                            <Checkbox
                                                checked={checked.indexOf(value) !== -1}
                                                tabIndex={-1}
                                                disableRipple
                                                inputProps={{
                                                    'aria-labelledby': labelId,
                                                }}
                                            />
                                        </ListItemIcon>
                                        <ListItemText id={labelId} primary={`${value}`} />
                                    </ListItem>
                                );
                            })}
                        </List>
                    </Card>
                );
                return (
                    <Dialog onClose={() => setShowNewRolForm(false)} open={showNewRolForm} maxWidth='lg' >
                        <DialogTitle fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }}>{estamosEditando ? 'Editar rol ' + selected.nombre + ':' : 'Nuevo rol:'}</DialogTitle>
                        <DialogContent dividers>
                            <FormContainer defaultValues={defaultValues}>
                                <Grid container
                                    spacing={0}
                                    direction="row"
                                    alignitems="center"
                                    justifyContent="center"
                                >
                                    <Grid item xs={12} sx={{ marginBottom: '1vh' }}> {/*el padding-top soluciona un problema con el label: se oculta cuando el usuario hace clicl. esto solo pasa para la primera fila de inputs*/}
                                        <TextFieldElement sx={{ width: '100%' }} required label='Nombre del rol' name='nombre' onChange={(e) => { defaultValues.nombre = e.target.value; defaultValues.descripcion = e.target.value; setName(e.target.value) }} />
                                    </Grid>
                                    <Grid item  >
                                        {CustomList('Permisos Denegados', left)}
                                    </Grid>
                                    <Grid item >
                                        <Grid container direction="column" alignitems="center" sx={{ marginTop: "23vh" }}>
                                            <Button
                                                sx={{ my: 0.5, marginRight: '10px', marginLeft: '10px' }}
                                                variant="outlined"
                                                size="small"
                                                onClick={handleCheckedRight}
                                                disabled={leftChecked.length === 0}
                                                aria-label="move selected right"
                                            >
                                                &gt;
                                            </Button>
                                            <Button
                                                sx={{ my: 0.5, marginRight: '10px', marginLeft: '10px' }}
                                                variant="outlined"
                                                size="small"
                                                onClick={handleCheckedLeft}
                                                disabled={rightChecked.length === 0}
                                                aria-label="move selected left"
                                            >
                                                &lt;
                                            </Button>
                                        </Grid>
                                    </Grid>
                                    <Grid item  >
                                        {CustomList('Permisos Elegidos', right)}
                                    </Grid>
                                </Grid>
                            </FormContainer>
                        </DialogContent>
                        <DialogActions>
                            <Button variant="outlined" onClick={() => setShowNewRolForm(false)} sx={{ marginTop: '10px' }}>{"Cancelar"}</Button>
                            <Button variant="contained" type={'submit'} onClick={() => onSubmit(defaultValues)} sx={{ marginRight: '5px', marginTop: '10px' }}>{"Aceptar"}</Button>
                        </DialogActions>
                    </Dialog>
                )
            };

            const DelRolForm = (props) => {
                let roles = selectedRows.filter(r => r.selected === true)
                let esRoles = roles.length > 1
                const onSubmit = () => {
                    let ids = roles.map(r => r.rolId)
                    dispatch(deleteRol(ids)).unwrap().then(console.log).catch(console.log)
                    setShowDeleteRolForm(false);
                }
                return (
                    <Dialog onClose={() => setShowDeleteRolForm(false)} open={showDeleteRolForm}>
                        <DialogTitle>{esRoles ? 'Eliminar roles' : 'Eliminar rol'}</DialogTitle>
                        <Dialog
                            open={showDeleteRolForm}
                            onClose={() => setShowDeleteRolForm(false)}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }} id="alert-dialog-title">
                                {esRoles ? 'Eliminar roles:' : "Eliminar rol:"}
                            </DialogTitle>
                            <DialogContent dividers>
                                <Typography>
                                    {esRoles ? `Esta seguro de que quiere eliminar los siguientes roles?`
                                        : `Esta seguro de que quiere eliminar el siguiente rol?`}
                                </Typography>
                                {roles?.map(rol => {
                                    const labelId = `delete-list-all-item-${rol.rolId}-label`;
                                    return (
                                        <Fragment key={`eliminar-${rol.rolId}`}>
                                            <List>
                                                <ListItem label={labelId}>
                                                    <ListItemText>{`ID: ${rol.rolId} - Nombre: ${rol.nombre}`}</ListItemText>
                                                </ListItem>
                                            </List>
                                        </Fragment>
                                    )
                                })}
                            </DialogContent>
                            <DialogActions>
                                <Button disabled={fetching > 0}
                                    variant="outlined"
                                    sx={{ marginRight: '5px', marginButtom: '15px', fontWeight: "bold" }} onClick={() => setShowDeleteRolForm(false)}>Cancelar</Button>
                                <Button variant="contained" onClick={onSubmit} autoFocus>Confirmar</Button>
                            </DialogActions>
                        </Dialog>
                    </Dialog >
                )
            };

            return (
                <Fragment>
                    <IconButton disabled={fetching > 0} className="mb-3" variant="contained" color='primary' onClick={() => setShowNewRolForm(true)}><AddIcon /></IconButton>
                    <IconButton disabled={fetching > 0 || selectedRows?.filter(r => r.selected === true)?.length !== 1} className="mb-3" variant="contained" color='info' onClick={() => { setShowNewRolForm(true); setEstamosEditando(true) }}><EditIcon /></IconButton>
                    <IconButton disabled={fetching > 0 || selectedRows?.filter(r => r.selected === true)?.length === 0} className="mb-3" variant="contained" color='danger' onClick={() => setShowDeleteRolForm(true)}><DeleteIcon /></IconButton>
                    <NewRolForm />
                    <DelRolForm />
                </Fragment>)
        };
        return (
            <Fragment>
                <BtnBar></BtnBar>
                <Box sx={{ height: 600, width: '100%', marginBottom: '13em' }}>
                    <Paper square elevation={2} style={{ position: 'sticky' }} sx={{ maxHeight: '60px', minHeight: '60px', marginTop: '9px' }}>
                        <Grid container spacing={0}  >
                            <Grid item xs={0.5} >
                                <Typography  ></Typography>
                            </Grid>
                            <Grid item alignitems='center' display="flex" xs={3} >
                                <Typography sx={{ marginLeft: '10px', marginTop: '18px' }} >Rol</Typography>
                            </Grid>
                            <Grid item alignitems='center' display="flex" justifyContent="center" xs={2.5} >
                                <Typography sx={{ marginTop: '18px' }} >Permisos</Typography>
                            </Grid>
                            <Grid item alignitems='center' display="flex" justifyContent="center" xs={2.5} >
                                <Typography sx={{ marginTop: '18px' }} >Permisos Denegados</Typography>
                            </Grid>
                            <Grid item alignitems='center' display="flex" justifyContent="center" xs={2.5} >
                                <Typography sx={{ marginTop: '18px' }} >Personas con el rol</Typography>
                            </Grid>
                        </Grid>
                    </Paper>
                    {rows.map((rol, i) => {
                        return (
                            <Fragment key={`fragment-accordion-roles-${rol.rolId}`}>
                                <Accordion key={`accordion-${rol.rolId}`}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls={`panel${rol.rolId}a-content`}
                                        id={`panel${rol?.rolId}a-header`}
                                    >
                                        <Grid container spacing={0} >
                                            <Grid item xs={0.5} >
                                                <Checkbox
                                                    checked={selectedRows.find(r => r.rolId === rol?.rolId)?.selected}
                                                    onChange={() => setSelectedRows([...selectedRows.map(c => c.rolId === rol?.rolId ?
                                                        ({ ...c, selected: !c.selected }) :
                                                        c
                                                    )])}
                                                    inputProps={{ 'aria-label': 'controlled' }}
                                                />
                                            </Grid>
                                            <Grid item xs={3} >
                                                <Typography sx={{ marginRight: '10px', marginTop: '9px' }} >ID: {rol?.rolId} - {rol?.nombre}</Typography>
                                            </Grid>
                                            <Grid item alignitems='center' display="flex" justifyContent="center" xs={2.5} >
                                                <Typography sx={{ marginTop: '9px' }} >{rol?.permisosRol?.length}</Typography>
                                            </Grid>
                                            <Grid item alignitems='center' display="flex" justifyContent="center" xs={2.5} >
                                                <Typography sx={{ marginTop: '9px' }} >{rol?.permisosDen?.length}</Typography>
                                            </Grid>
                                            <Grid item alignitems='center' display="flex" justifyContent="center" xs={2.5} >
                                                <Typography sx={{ marginTop: '9px' }} >{rol?.personasRol?.length}</Typography>
                                            </Grid>
                                        </Grid>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Grid container spacing={0} alignItems={'center'}>
                                            <Grid item xs={4.2}  >
                                                <Typography variant='h6' color='text.secondary' sx={{ marginLeft: '10px', marginTop: '9px', marginBottom: '15px' }} >Pemisos: </Typography>
                                            </Grid>
                                            <Grid item xs={2.5} alignitems='center' display="flex" justifyContent="center">
                                                <Typography sx={{ marginLeft: '0px', marginTop: '9px', marginBottom: '15px' }} >Ver permisos denegados</Typography>
                                            </Grid>
                                            <Grid item xs={1.2}  >
                                                <Switch sx={{ marginBottom: '3px' }} key={'switch-' + rol?.rolId} label={`Switch permisos den ${rol?.rolId}`} size="small" color="primary" disabled={rol?.permisosDen?.length === 0} onChange={() => setInterruptor(interruptor.map(s => s.rolId === rol?.rolId ? { rolId: s.rolId, switch: !(s.switch) } : s))} />
                                            </Grid>
                                            <Grid item xs={2} alignitems='center' display="flex" justifyContent="center">
                                                <Typography sx={{ marginLeft: '0px', marginTop: '9px', marginBottom: '15px' }} >Ver personas con el rol</Typography>
                                            </Grid>
                                            <Grid item xs={1}  >
                                                <IconButton className="mb-3" sx={{ marginBottom: '3px' }} variant="contained" color='primary' onClick={() => setPersonasModal(rol.personasRol)}>
                                                    <VisibilityIcon key={'visibility-' + rol?.rolId} /></IconButton>

                                            </Grid>
                                        </Grid>
                                        <Accordion>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls={`panela-content`}
                                                id={`panel${rol?.accesos}a-header`}
                                                alignitems="center"
                                            >
                                                <VpnKeyIcon sx={{ marginRight: '11px' }} color={interruptor.find(i => i.rolId === rol.rolId).switch ?
                                                    'secondary' : 'primary'}></VpnKeyIcon>
                                                <Typography sx={{ marginRight: '11px' }} > Accesos ({(interruptor.find(i => i.rolId === rol.rolId).switch ?
                                                    rol?.accesosDen : rol?.accesos).length})</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <Grid container spacing={0} display='flex' flexWrap='wrap'>
                                                    {(interruptor.find(i => i.rolId === rol.rolId).switch ?
                                                        rol?.accesosDen : rol?.accesos).map(permisoLabel =>
                                                            <Grid key={`gridaccesos${permisoLabel}${rol.rolId}`} item xs={5} sx={{ minWidth: '300px', maxWidth: '300px', marginLeft: '20px' }}>
                                                                <Typography> <FiberManualRecordIcon color={interruptor.find(i => i.rolId === rol.rolId).switch ?
                                                                    'secondary' : 'primary'} sx={{ paddingTop: '8px' }} fontSize='small' />  {permisoLabel}</Typography>
                                                            </Grid>)}
                                                </Grid>
                                            </AccordionDetails>
                                        </Accordion>
                                        <Accordion>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls={`panel${rol?.lecturas}a-content`}
                                                id={`panel${rol?.lecturas}a-header`}
                                                alignitems="center"
                                            >
                                                <VisibilityIcon sx={{ marginRight: '11px' }} color={interruptor.find(i => i.rolId === rol.rolId).switch ?
                                                    'secondary' : 'primary'}></VisibilityIcon>
                                                <Typography sx={{ marginRight: '11px' }}>Lecturas ({(interruptor.find(i => i.rolId === rol.rolId).switch ?
                                                    rol?.lecturasDen : rol?.lecturas).length})</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <Grid container spacing={0} display='flex' flexWrap='wrap'>
                                                    {(interruptor.find(i => i.rolId === rol.rolId).switch ?
                                                        rol?.lecturasDen : rol?.lecturas).map(permisoLabel =>
                                                            <Grid key={`grid-lecturas-${rol.rolId}-${permisoLabel}-${rol.nombre}`} item xs={5} sx={{ minWidth: '300px', maxWidth: '300px', marginLeft: '20px' }}>
                                                                <Typography> <FiberManualRecordIcon color={interruptor.find(i => i.rolId === rol.rolId).switch ?
                                                                    'secondary' : 'primary'} sx={{ paddingTop: '8px' }} fontSize='small' />  {permisoLabel}</Typography>
                                                            </Grid>)}
                                                </Grid>
                                            </AccordionDetails>
                                        </Accordion>
                                        <Accordion>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls={`panel${rol?.escrituras}a-content`}
                                                id={`panel${rol?.escrituras}a-header`}
                                                alignitems="center"
                                            >
                                                <EditIcon sx={{ marginRight: '11px' }} color={interruptor.find(i => i.rolId === rol.rolId).switch ?
                                                    'secondary' : 'primary'}></EditIcon>
                                                <Typography sx={{ marginRight: '11px' }}>Ediciones ({(interruptor.find(i => i.rolId === rol.rolId).switch ?
                                                    rol?.escriturasDen : rol?.escrituras).length})</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <Grid container spacing={0} display='flex' flexWrap='wrap'>
                                                    {(interruptor.find(i => i.rolId === rol.rolId).switch ?
                                                        rol?.escriturasDen : rol?.escrituras).map(permisoLabel =>
                                                            <Grid key={`gridescrituras${permisoLabel}${rol.rolId}`} item xs={5} sx={{ minWidth: '300px', maxWidth: '300px', marginLeft: '20px' }}>
                                                                <Typography> <FiberManualRecordIcon color={interruptor.find(i => i.rolId === rol.rolId).switch ?
                                                                    'secondary' : 'primary'} sx={{ paddingTop: '8px' }} fontSize='small' /> {permisoLabel}</Typography>
                                                            </Grid>)}
                                                </Grid>
                                            </AccordionDetails>
                                        </Accordion>
                                    </AccordionDetails>
                                </Accordion>

                            </Fragment>
                        )
                    })}
                </Box>
                <PersonasModal></PersonasModal>
            </Fragment>
        );
    }
    return (
        <Fragment>
            <Header></Header>
            <RolesTable></RolesTable>
        </Fragment>
    )
}

export default RolesCat;